import React from 'react';

export function RecetarioIcon({ className = 'cls-1', ...props }) {
	return (
		<svg
			className='recetarioIcono'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 20.3 25.44'
			{...props}
		>
			<title>icono01</title>
			<g id='Layer_2' data-name='Layer 2'>
				<g id='Contenido-Home'>
					<g id='NewGroupe2'>
						<g id='NewGroup16-1'>
							<path
								className={className}
								d='M3,23.54H20.29v-.41a.41.41,0,0,0,0-.11.58.58,0,0,0-.56-.47H1.44a1.44,1.44,0,0,0-1,.43l-.09.1a1.44,1.44,0,0,0-.33,1,1.47,1.47,0,0,0,1.47,1.33H19.72a.58.58,0,0,0,.57-.58v-.41H3a.46.46,0,0,1,0-.91Z'
							></path>
							<path
								className={className}
								d='M16.41,6.58,14.19,9.42a2.57,2.57,0,0,1-1.24.91,2.15,2.15,0,0,0-1.11.77l-.7.89-.63.82-4,5.08a.27.27,0,0,1-.36.1L6,17.85a.28.28,0,0,1,0-.38l4.15-5.3.6-.76.57-.73a2.23,2.23,0,0,0,.49-1.26A2.51,2.51,0,0,1,12.37,8l2.22-2.84A.55.55,0,0,1,15,4.93a.17.17,0,0,1,.12,0c.12.09.09.33-.07.53L12.87,8.27c-.09.11-.11.25,0,.3s.19,0,.28-.11l2.17-2.77c.15-.2.38-.28.5-.19h0c.13.1.1.34-.06.54L13.56,8.82a.34.34,0,0,0-.08.19.13.13,0,0,0,0,.1c.07.06.2,0,.28-.1L16,6.24c.16-.2.39-.29.51-.19s.09.33-.07.53ZM14.77,18.42c-.34.22-1.24-.47-1.44-.82L10.7,13.13l.65-.83,3.17,4.54c.23.33.59,1.36.25,1.58ZM5.7,4.39c1.09-.7,2.75,0,3.71,1.45A3.53,3.53,0,0,1,9.88,9a1.56,1.56,0,0,0,.17,1.48l.47.67-.58.74-.57-1a1.55,1.55,0,0,0-1.28-.77A3.51,3.51,0,0,1,5.47,8.37c-1-1.5-.86-3.28.23-4ZM20.3,1.54A1.54,1.54,0,0,0,18.76,0H1.84A1.54,1.54,0,0,0,.3,1.54V21.88a2.44,2.44,0,0,1,1.14-.29H19.72a1.43,1.43,0,0,1,.58.12V1.54Z'
							></path>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
}

export default RecetarioIcon;

